<template>
  <div>
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img">
          <img src="/img/Badoo.svg" alt="" />
        </div>
        <div style="display: flex; align-items: center;" v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>
      </div>
    </div>
    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v,key) in banners" :key="key">
            <van-image class="banner_img"  :src="`${v.url}`" width="100%" height="160px">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
    </div>
    <div style="padding: 8px;">
      <van-notice-bar
        class="notice-swiper"
        color="rgb(62, 30, 136)"
        background="#fff"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAAAXNSR0IArs4c6QAAAzpJREFUSEutlkFoHGUUx///2Z3daAOa6s5HZqa1rcFeSm0IaTqfJeZgixQxt6qH5qQgUjCBioKHepAWrGArpoIK0ktAEdpDoEQsFEt32yhSqwdPtpjZhtn14DFks/NkZpu4MbPZCczchu+9/2++9/3f+4bY4qPU/m2S750gw18C/9btraRzK8El1xugcJbEXgH+qeUL/bh/fSmtRmqY5WiPxCyA7avioWCwXi3fyRSmXP2GANMEzHbhkBytL9y8kRnMcr1zBE8lCYZNjtYXM4D19Q09VthWnAFwrNOXJ8H67KGdBRY+BlAOqpXz7bmJZ6bUwd2Sz1+NjLBZiZJglqOnSbwV5QnwXc0vvAZcX4neN8BK9shhg7nLIJ7sdhaJMFsfpYErAB6J80W+DaqVVzbAYiMILpLIdwNF653OrGR7gwY5B6L0cIfv1vzyR7QcfZGUFyEgyF1pIGvW32iQHIBmtG65I/uJ3DyAIiDLTRq7qVwtWwGss34bbLs9vMOkeRPE3cAvvxQDbe8UDZ6LqyByITOYZY8coZH7PhamnKwvVKaBIVM5RR+EJcBiZrB4J46+QeIwBH8H1UJ/5ELl6i8BvB4bJKsytsoWO3GuZYrmszX/9l3LOfQmaXyeOezxfv1UMYf7MSyU52oPKuWSc+i4QeObzGGW402QvBSbqNF4Ogh++lO53tsA40mSWRlLpbFeFpf/IOAA+Dnwy8OtFtBXCIxnClO2HkdrcgBheCR4cOsHpbQFE39FvSbAr1FTN9JOjP/3Y/sEse2hR5ssfgbiTuCXP22507tEcqKVJ5NUSu+DCU8ES4BMkRxM2+SbXTHtLhSIXwOeWT+Id431WI3lL0icSAPsOBtd7z0DPLumIfJCUK1cS75iHP0+iA+7AZNgyvEmQX7yX65MBn7lQmyQToLK1q/CwNcAejrFJF4xrv6AwGkBGoS8swraFBYtPrFDD+dDzEazLQnYoYw5ZXvHYeD3wK/81p7X9e9KqeE9YppzBAY2c2O3knfd2apA1C9iIgIeaBcNiefrC+Uf04BSw6LA6E8Y+d4ZEC+viTdW9gTB/L3MYQ8FqWzvDMiTIeSrerUylRYUxf0L2HxhjnpTPGYAAAAASUVORK5CYII="
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <div style="width: 96%; margin: 8px auto; border-radius: 8px; padding: 8px; color: rgb(255, 255, 255);">
      <div style="padding-bottom: 5px;">
        <span style="display: flex; justify-content: flex-start; align-items: center; font-size: 0.93333rem; color: rgba(0, 0, 0, 0.87);">
          {{$t("index.Highend_area")}}
          <span class="sub">{{$t("index.extreme")}}</span>
        </span>
      </div>
      <div style="width: auto; display: flex; overflow-x: auto; position: relative; align-items: center;">
        <div style="display: flex; flex-direction: column; align-items: baseline;">
          <ul style="display: flex; flex-wrap: nowrap; padding: 0px; list-style: none; margin: 0.4rem 0 0;">
            <li
              v-for="item in datalist.slice(0, 10)"
              :key="item.id"
              style="flex: 0 0 4.2rem; height: 4.2rem; overflow: hidden; margin-right: 0.4rem; position: relative; border-radius: 0.2rem;"
              @click="toDetail(item.id)"
            >
              <img
                :src="item.img_url"
                style="width: 100%; height: 100%; display: block; object-fit: cover;"
              />
              <span style="position: absolute; z-index: 9; background-color: #ebcaaf; color: #8d684b; width: 3.8rem; height: 3.8rem; transform: rotate(45deg); left: 3rem; top: -2.2rem;">
                <i style="position: absolute; bottom: 0; left: 0.7rem; font-size: 0.5rem; font-weight: 600;">{{$t("index.airborne")}}</i>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  
    <div style="width: 96%; margin: 0px auto; overflow: hidden; padding: 0.66667rem 0.66667rem 0;">
      <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 0.93333rem; color: rgba(0, 0, 0, 0.87); font-weight: 700;">
        {{$t("index.popularity_ranking")}}
      </div>
      <ul style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 0 2px; margin: 0; list-style: none;">
        <li
          v-for="(item, index) in popularityRanking"
          :key="index"
          style="text-align: center; box-sizing: border-box; padding: 20px 0 0; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 25%;"
        >
          <div style="width: 70px; height: 70px; overflow: hidden; position: relative; margin: 0 auto;">
            <img :src="item.img" style="width: 70px; height: 70px; border-radius: 10px;" />
          </div>
          <p style="font-size: 12px; padding-top: 0.5rem; color: rgb(52, 25, 106); font-weight: 700;">{{item.name}}</p>
        </li>
      </ul>
    </div>
    <div class="tab-bar">
      <div class="tab-bar-inner">
        <a :class="{act: tabIndex===0}" @click="tabIndex=0">{{$t("index.partners")}}</a>
        <a :class="{act: tabIndex===1}" @click="tabIndex=1">{{$t("index.dating_records")}}</a>
        <a :class="{act: tabIndex===2}" @click="tabIndex=2">{{$t("index.company_profile")}}</a>
      </div>
    </div>
    <div style="border-radius: 10px; margin-left: 1.5%; padding: 5px 5px 20px; width: 96%; display: block;" v-if="tabIndex===0">
      <ul style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 0 2px; margin: 0; list-style: none;">
        <li
          v-for="(item, index) in partnerList1"
          :key="index"
          style="text-align: center; box-sizing: border-box; padding: 10px 0 0; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 33.3%;"
        >
          <div style="width: 100px; height: 50px; overflow: hidden; position: relative; margin: 0 auto;">
            <img :src="item" style="width: 100px; height: 50px; border-radius: 10px;" />
          </div>
        </li>
      </ul>
      <ul style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 0 2px; margin: 0; list-style: none;">
        <li
          v-for="(item, index) in partnerList2"
          :key="index"
          style="text-align: center; box-sizing: border-box; padding: 10px 0 0; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 33.3%;"
        >
          <div style="width: 100px; height: 50px; overflow: hidden; position: relative; margin: 0 auto;">
            <img :src="item" style="width: 100px; height: 50px; border-radius: 10px;" />
          </div>
        </li>
      </ul>
    </div>
    <div style="padding: 10px; line-height: 24px; font-size: 14px; border-radius: 10px; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); width: 94%; margin: 0 auto 30px; overflow: hidden; color: #fff;" v-if="tabIndex===2">
      {{$t("index.company_desc")}}
    </div>
    <div
      v-if="tabIndex===1"
      style="border-radius: 10px; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); width: 94%; margin: 0 auto 30px; overflow: hidden; padding-bottom: 10px;"
    >
      <div class="OnlineMatching">
        <div class="OnlineMatching-track">
          <ul class="item">
            <li v-for="(name, i) in datingNames" :key="i">{{ name }} {{$t("index.successful_date")}}</li>
          </ul>
          <ul class="item" aria-hidden="true">
            <li v-for="(name, i) in datingNames" :key="'dup-'+i">{{ name }} {{$t("index.successful_date")}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      tabIndex: 0,
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      popularityRanking: [
        { img: '/img/shop/nan1.png', name: 'Popularity Ranking1' },
        { img: '/img/shop/nan2.png', name: 'Popularity Ranking2' },
        { img: '/img/shop/nan3.png', name: 'Popularity Ranking3' },
        { img: '/img/shop/nv1.png', name: 'Popularity Ranking4' }
      ],
      partnerList1: [
        'http://www.okcupiw.com/base/ico//20260208/460d4e7283ade6c6a779a98fd7cc90db.png',
        'http://www.okcupiw.com/base/ico//20260208/4126c17b58e2daa79f854e05e6cc1351.png',
        'http://www.okcupiw.com/base/ico//20260208/173c0a48204176cff8590cd4872f2fff.png'
      ],
      partnerList2: [
        'http://www.okcupiw.com/base/ico//20260208/4eb2a15cd2555a85e5294284447e0d52.png',
        'http://www.okcupiw.com/base/ico//20260208/cfe82bd430c1becf734214344eaa1086.png',
        'http://www.okcupiw.com/base/ico//20260208/5c44b264ac798386822e4eae4072b718.png'
      ],
      datingNames: [
        'nPV****ic0', 'Aka****UC7', 'FYR****KTf', 'BeB****IGX', 'Lum****sMZ',
        'avv****I1U', 'uLa****F2J', 'Qge****mxY', 'r50****YFP', 'Zsa****AGj',
        'RON****HwL', 'x9C****gFQ', 'WrS****EeJ', '9s4****ROK', 'EKX****vae',
        '2ni****tRc', 'qN5****w3I', 'Zt3****M6X', 'Pok****Sss', 'U9f****FZK',
        'nPh****ajZ', '0JB****Qq1', 'Xpb****n9b', 'Zht****PdR', 'r3t****1ee',
        'M1r****F9H', 'Jrv****lNu', 'aeM****K4k', 'HnD****fmJ', 'ACw****Kcn'
      ]
    };
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData);
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
      console.log(res,11)
      });
    },
    getBanner(data){
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token;
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
  },

  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 13vw;
  background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 5.333vw;
  color: #fff;
  .img {
    height: 10.667vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.banner_swiper {
  width: 100%;
  padding: 0 2.667vw;
}
.banner_img {
  border-radius: 4vw;
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.sub {
  display: inline-block;
  margin-left: 0.46667rem;
  border-radius: 0.46667rem 0;
  background: rgb(63, 58, 91);
  color: rgb(235, 202, 175);
  padding: 0.04rem 0.6rem;
  font-size: 18x;
}
.gdgride {
  padding-right: 5.333vw;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 1.067vw;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 0.667vw;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  background: #fff;
  padding: 1.333vw;
  border-radius: 2.667vw;
  margin-top: 2.667vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 2.133vw;
  margin-right: 5.333vw;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 0.667vw;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 160px;
  overflow: hidden;
}
.OnlineMatching-track {
  animation: onlineMatchingScroll 30s linear infinite;
  will-change: transform;
}
.OnlineMatching .item {
  margin: 0;
  padding: 0;
  list-style: none;
}
.OnlineMatching ul li {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 4vw;
}
@keyframes onlineMatchingScroll {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50%);
  }
}
.tab-bar {
  width: 94%;
  margin: 20px auto 15px;
}
.tab-bar-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.tab-bar-inner a {
  flex: 1;
  text-align: center;
  padding: 1.5vw 0;
  cursor: pointer;
  font-size: 3.2vw;
  font-weight: 500;
  color: #999;
  background-color: #f0f0f0;
  border-radius: 999px;
  transition: all 0.3s ease;
}
.tab-bar-inner a.act {
  color: #fff !important;
  font-weight: 700;
  background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));
}
</style>
